var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserProfileCircle1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.125 0h23.75 -5.46392e-09c.0690356-3.01764e-09.125.0559644.125.125v23.75 0c0 .0690356-.0559644.125-.125.125h-23.75 -5.46392e-09c-.0690356-3.01764e-09-.125-.0559644-.125-.125v-23.75l1.44329e-15 1.88745e-08c-1.04241e-08-.0690356.0559644-.125.125-.125Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M15.611 16.5h-7.222l3.21351e-08 5.76428e-11c-.306842-.000550373-.55545-.249158-.556-.556v-.451l-4.87439e-08 1.62824e-05c.0038376-1.28341 1.04357-2.32271 2.32698-2.32602h3.68l1.38533e-07 3.5566e-10c1.28341.00329499 2.32315 1.04259 2.327 2.326v.451l-7.03082e-12 3.91971e-09c-.000550482.306836-.249148.55544-.555984.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12 11l-6.90787e-08-5.54223e-13c-1.24264-9.97932e-06-2.24999-1.00738-2.24998-2.25002 9.97932e-06-1.24264 1.00738-2.24999 2.25002-2.24998 1.23912 9.95105e-06 2.24501 1.00189 2.24996 2.241l9.15825e-09 2.9466e-06c.00386481 1.24374-1.00125 2.25512-2.24499 2.25899 -.00167056 5.19112e-06-.00334112 8.52337e-06-.00501169 9.99674e-06Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfileCircle1);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "static/media/user-profile-circle.1.c4c3053f057730910033fb729b1af14c.svg";
export { MemoForwardRef as ReactComponent };